(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moudhy-app-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moudhy-app-preview')) {
  customElements.define('moudhy-app-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = Array.from(this.querySelectorAll('[data-mapv-slide]'));
      this.buttons = Array.from(this.querySelectorAll('[data-mapv-select]'));
      this.play = this.querySelector('[data-mapv-play]');
      if (!this.slides.length || !this.play) return;
      this.index = 0;
      this.requestId = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.buttons.forEach((button, index) => button.addEventListener('click', () => {
        this.paused = true;
        this.sync();
        this.show(index);
      }, options));
      this.play.addEventListener('click', () => {
        this.paused = !this.paused;
        this.sync();
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', event => {
        if (event.target !== this.play) { this.paused = true; this.sync(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.sync();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.2 });
        this.observer.observe(this);
      } else { this.visible = true; }
      this.classList.add('is-ready');
      this.sync();
    }
    async show(index) {
      const requestId = ++this.requestId;
      const image = this.slides[index];
      if (!image) return;
      if (!image.complete) image.loading = 'eager';
      try { await image.decode(); } catch (error) {
        if (!image.naturalWidth) { this.paused = true; this.sync(); return; }
      }
      if (requestId !== this.requestId || !this.isConnected) return;
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.classList.toggle('is-paused', this.paused);
      this.play.setAttribute('aria-pressed', this.paused ? 'true' : 'false');
      this.play.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.paused && !this.motion.matches && this.visible && !this.hovered && !document.hidden) {
        this.timer = setTimeout(() => this.show((this.index + 1) % this.slides.length), 3000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.requestId++;
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
